import type { Resource } from '../../';
export const search_box_clear: Resource = {"default":"Clear Search"};
